<template lang="pug">
.display-text-container
  template(v-if="text && text !== ''")
    .container__content(
      v-html="formatText"
      ref="container"
      :class="[isCollapse ? 'container__content__collapse' : '']"
    )
    el-button(
      v-if="shouldShowButton"
      type="text"
      @click="isCollapse = !isCollapse"
    ) {{ isCollapse ? $t('展开') : $t('收起')  }}
  template(v-else)
    .container__content(ref="container") —
</template>

<script>
export default {
  props: {
    text: String,
    default: null
  },
  computed: {
    formatText () {
      return this.text.replace(/\n/g, '<br />')
    }
  },
  mounted () {
    this.shouldShowButton = this.$refs.container.getBoundingClientRect().height >= 250
    this.isCollapse = this.$refs.container.getBoundingClientRect().height >= 250
  },
  watch: {
    text () {
      this.$nextTick(() => {
        this.shouldShowButton = this.$refs.container.getBoundingClientRect().height >= 250
        this.isCollapse = this.$refs.container.getBoundingClientRect().height >= 250
      })
    }
  },
  data () {
    return {
      isCollapse: false,
      shouldShowButton: false
    }
  }
}
</script>

<style lang="stylus">
.display-text-container
  width 380px
  .container__content__collapse
    max-height 220px
    overflow hidden
</style>
